import { useEffect, useState } from "react";
import { newsService } from "../../../services/news.service";

export const useNews = (page = 1, limit = 6) => {
  const [news, setNews] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);

        const res = await newsService.getNews({
          page,
          limit,
          status: "published",
        });

        setNews(res.data.data || []);
        setPagination(res.data.pagination || {});
      } catch (error) {
        console.error("Fetch News Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [page, limit]);

  return {
    news,
    loading,
    pagination,
  };
};